import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ADMIN_RESTRICTED_ROUTE } from '../shell/admin-restricted-route.token';

export function roleGuard(requiredRole: string, redirectTo: readonly string[] = ['/']): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    return auth.role() === requiredRole ? true : router.createUrlTree(redirectTo as string[]);
  };
}

// US-C3-2: failing this gate stays in-shell (an "access denied" card), never bounces to `/`
// (which redirects unauthenticated traffic to login — the user IS authenticated here, just
// under-privileged).
export const domainAdminGuard: CanActivateFn = (route, state) =>
  roleGuard('domain_admin', inject(ADMIN_RESTRICTED_ROUTE))(route, state);
